<template>
    <v-layout row justify-center>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="550px"
            content-class="v-dialog--large"
        >
            <v-card>
                <v-card-title class="teal darken-2">
                    <span class="title" style="color: #fff;">{{ $t("lumber") }}</span>
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text>
                    <v-container grid-list-md py-0>
                        <v-flex xs12>
                            <v-layout wrap>
                                <v-flex xs6>
                                    <v-select
                                        v-model="species"
                                        :items="speciesFiltered"
                                        item-text="species"
                                        :label="`${$t('speciesAlt')} *`"
                                        v-if="speciesFiltered.length > 0"
                                        return-object
                                        required
                                    ></v-select>
                                </v-flex>
                                <v-flex xs6>
                                    <v-select
                                        v-model="boardType"
                                        :items="boardTypesList"
                                        item-text="title"
                                        item-value="id"
                                        :label="`${$t('boardType')} *`"
                                        required
                                    ></v-select>
                                </v-flex>
                                <v-flex xs6>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            {{ $t("dimension") }}
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-model="Tn"
                                                :label="`${$t('thickness')} *`"
                                                append-outer-icon="close"
                                                required>
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-model="Wn"
                                                :label="`${$t('width')} *`"
                                                mr-2
                                                required>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                <v-flex xs6>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            {{ $t("sawSize") }}
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-model="Ts"
                                                :label="`${$t('thickness')} *`"
                                                append-outer-icon="close"
                                                required>
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-model="Ws"
                                                :label="`${$t('width')} *`"
                                                required>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                <v-flex xs12>
                                    <v-select
                                        :items="lengthGroups"
                                        item-text="name"
                                        item-value="id"
                                        v-model="selectedLengthGroupId"
                                        dense
                                        :label="$t('lengthGroup')"
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12>
                                    <v-select
                                        v-model="selectedLengths"
                                        attach
                                        chips
                                        clearable
                                        return-object
                                        item-text="length"
                                        item-value="id"
                                        :items="lengths"
                                        :menu-props="lengthsMenuProps"
                                        :label="`${$t('lengths')}`"
                                        :hint="`${$t('messageEmptyLengthRange')}`"
                                        persistent-hint
                                        multiple
                                    >
                                        <template v-slot:prepend-item>
                                            <v-list-tile
                                                ripple
                                                @mousedown.prevent
                                                @click="selectAll"
                                                class="ma-0"
                                            >
                                                <v-list-tile-action class="ma-1">
                                                    <v-icon :color="selectedLengths.length > 0 ? 'blue darken-2' : ''">{{ icon }}</v-icon>
                                                </v-list-tile-action>
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{ $t('selectAll')}}</v-list-tile-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-divider class="mt-2"></v-divider>
                                        </template>
                                    </v-select>
                                </v-flex>

                                <v-flex xs6>
                                    <v-text-field
                                        v-model="price"
                                        :label="`${$t('priceM3')} *`"
                                        required>
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs6>
                                    <v-text-field
                                        v-model="expenses"
                                        :label="`${$t('expensesM3')} *`"
                                        required>
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-select
                                        multiple
                                        :items="filteredlumberGroups"
                                        item-text="name"
                                        item-value="id"
                                        v-model="selectedLumberGroupId"
                                        :label="$t('lumberGroup')"
                                        :disabled="this.$obj.isEmpty(species) || filteredlumberGroups.length == 0"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-container>
                    <small>{{ $t("requiredFieldPointer") }}</small>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions :class="{'grey lighten-4': !this.$vuetify.dark, 'grey darken-4': this.$vuetify.dark}">
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="(Tn == '') || (Wn == '') || (Ts == '') || (Ws == '') || !species.species"
                        color="success"
                        @click="saveDataClick"
                    >
                    {{ $t("save") }}
                    </v-btn>
                    <v-btn color="error" @click="dialog = false">{{ $t("cancel") }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <message-box ref="MessageBox"/>
    </v-layout>
</template>

<script>
    import MessageBox from "./MessageBox";

    export default {
        name: "EditLumberDialog",

        components: {
            MessageBox
        },

        data () {
            return {
                dialog: false,
                dataUpdated: false,

                dimensionId: 0,
                boardType: 1,
                boardTypesList: [
                    { id: 0, title: this.$t("centralBoard") },
                    { id: 1, title: this.$t("sideBoard") },
                    { id: 2, title: this.$t("centralAndSideBoard") }
                ],
                Tn: 0,
                Wn: 0,
                Ts: 0,
                Ws: 0,
                lengthsMenuProps: {
                    "closeOnClick":        false,
                    "closeOnContentClick": false,
                    "openOnClick":         false,
                    "maxHeight":           150
                },
                lengths:         [],
                selectedLengths: [],
                price:           0,
                expenses:        0,
                species:         {},
                speciesList:     [],

                lengthGroups:    [],
                selectedLengthGroupId: null,

                lumberGroups:    [],
                selectedLumberGroupId: [],
                filteredlumberGroups: []
            }
        },

        computed: {
            icon () {
                if (this.checkAllLen) { return "mdi-close-box"; }
                if (this.checkSomeLen) { return "mdi-minus-box"; }
                return "mdi-checkbox-blank-outline";
            },

            checkAllLen () {
                return this.selectedLengths.length === this.lengths.length;
            },

            checkSomeLen () {
                return this.selectedLengths.length > 0 && !this.checkAllLen;
            },

            speciesFiltered () {
                return this.speciesList.filter(item => this.$store.getters.user.settings.selectedSpecies.includes(item.id));
            }
        },

        mounted () {
            this.loadLengths();
            this.loadSpecies();
            this.loadLengthGroups();
            this.loadLumberGroups();

        },

        watch: {
            /* При показе формы сбрасываем флаг изменения данных */
            dialog: function (val) {
                if (val) {
                    this.dataUpdated = false;

                    if (this.dimensionId == 0) {
                        this.boardTypesList = [
                            { id: 0, title: this.$t("centralBoard") },
                            { id: 1, title: this.$t("sideBoard") },
                            { id: 2, title: this.$t("centralAndSideBoard") }
                        ];
                    } else {
                        this.boardTypesList = [
                            { id: 0, title: this.$t("centralBoard") },
                            { id: 1, title: this.$t("sideBoard") }
                        ];
                    }
                }
            },

            selectedLengthGroupId: function (val) {
                if (val != 0) {
                    this.selectedLengths = [];
                    let ids = this.lengthGroups.filter(data => data.id == val).length > 0
                        ? this.lengthGroups.filter(data => data.id == val)[0].lengthIds
                        : [];

                    this.selectedLengths = this.lengths.filter(data => ids.includes(data.id));
                }
            },

            species: function(val) {
                this.filteredlumberGroups = this.lumberGroups.filter(data => data.speciesId == val.id);
                //this.selectedLumberGroupId = [];
            }
        },

        methods: {
            /**
             * Удаляет незначащие нули
             *
             * @param {number} val Исходное число с плавающей точкой
             *
             * @returns {number}
             */
            /*
            dropZeros (val) {
                let result = parseFloat(val);

                result = result.toFixed(3).substring(result.toFixed(3).length, result.toFixed(3).length - 1) == "0"
                    ? parseFloat(result.toFixed(2))
                    : parseFloat(result.toFixed(3));

                if (result == parseInt(val)) {
                    result += ".0";
                }

                return result;
            },
            */

            /**
             * Загрузка списка длин
             */
            loadLengths () {
                this.axios.get(`${this.$config.apiURL}lengths/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let lengthsInfo = response.data.lengths

                            this.lengths = [];
                            lengthsInfo.forEach((item) => {
                                //if (item.Visible) {
                                    this.lengths.push({
                                        id:     item.id,
                                        length: this.$num.dropZeros((item.Ln / 1000)) + " " + this.$t("m")
                                    });
                                //}
                            });
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData") + ". " +this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadLengthsData"));
                        }
                    });
            },

            /**
             * Загрузка групп длин
             */
            loadLengthGroups () {
                this.axios.get(`${this.$config.apiURL}length_groups/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let groups = response.data.groups;

                            this.lengthGroups = [];

                            groups.forEach((item) => {
                                //if (item.Visible) {
                                    let lengthIds = [];
                                    item.LengthGroupsData.forEach(data => {
                                        lengthIds.push(parseInt(data.LengthId));
                                    });
                                    this.lengthGroups.push({
                                        id:        item.id,
                                        name:      item.Name,
                                        lengthIds: lengthIds,
                                    });
                                //}
                            });
                        }

                        if (this.lengthGroups.filter(data => data.id == 0).length == 0) {
                            this.lengthGroups.unshift({
                                id:        0,
                                name:      this.$t("noGroup"),
                                lengthIds: [],
                            });
                        //} else {
                        //    this.groups[0].name = this.$t("noGroup");
                        }
                    })
                    .catch(error => {

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData"));
                        }
                    });
            },

            /**
             * Загрузка групп пиломатериалов
             */
            loadLumberGroups () {
                this.axios.get(`${this.$config.apiURL}lumber_groups/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let groups = response.data.groups;

                            this.lumberGroups = [];

                            groups.forEach((item) => {
                                //if (item.Visible) {
                                    let lumberIds = [];

                                    item.LumberGroupsData.forEach(data => {
                                        lumberIds.push(parseInt(data.LumberId));
                                    });

                                    this.lumberGroups.push({
                                        id:        item.id,
                                        name:      item.Name,
                                        speciesId: item.Species.id,
                                        lumberIds: lumberIds
                                    });
                                //}
                            });

                            if (this.species) {
                                this.filteredlumberGroups = this.lumberGroups.filter(data => data.speciesId == this.species.id);
                            }
                        }

                        if (this.lumberGroups.filter(data => data.id == 0).length == 0) {
                            this.lumberGroups.unshift({
                                id:        0,
                                name:      this.$t("noGroup"),
                                speciesId: this.selectedSpeciesId,
                                lumberIds: [],
                            });
                            //this.selectedGroupId = 0;
                        }
                    })
                    .catch(error => {

                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadGroupsData"));
                        }
                    });
            },

            /**
             * Загрузка списка пород
             */
            loadSpecies () {
                this.axios.get(`${this.$config.apiURL}species/`, { withCredentials: true })
                    .then(response => {
                        if (response.data.status == "success") {
                            let speciesInfo = response.data.species

                            this.speciesList = [];

                            speciesInfo.forEach((item) => {
                                if (item.Visible) {
                                    this.speciesList.push({
                                        id:      item.id,
                                        species: this.$t(item.Name)
                                    });
                                }
                            });
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData") + ". " +this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantLoadSpeciesData"));
                        }
                    });
            },

            /**
             * Сброс значений полей формы
             */
            resetForm () {
                this.dataUpdated     = false;
                this.boardType       = 0;
                this.companyId       = 0;
                this.dimensionId     = 0;
                this.Tn              = "";
                this.Wn              = "";
                this.Ts              = "";
                this.Ws              = "";
                this.species         = {};
                this.boardType       = 0;
                this.lengths         = [];
                this.selectedLengths = [];
                this.price           = 0;
                this.expenses        = 0;
            },

            /**
             * Сохранение данных
             */
            saveData () {
                let newLumberId;

                if (this.boardType == 2) {
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}lumber/`,
                        data: {
                            speciesId:   this.species.id,
                            Tn:          this.Tn,
                            Wn:          this.Wn,
                            Ts:          this.Ts,
                            Ws:          this.Ws,
                            BoardType:   0,
                            LengthsJSON: JSON.stringify(this.selectedLengths),
                            Price:       this.price,
                            Expenses:    this.expenses
                        },
                        withCredentials: true
                    }).then( response => {
                        if (response.data.status == "success") {
                            newLumberId = response.data.lumber.id;

                            this.filteredlumberGroups.forEach(group => {
                                if (this.selectedLumberGroupId.includes(group.id)) {
                                    this.axios({
                                        method: "patch",
                                        url: `${this.$config.apiURL}lumber_groups/${group.id}/`,
                                        data: {
                                            name: group.name,
                                            speciesId: group.speciesId,
                                            dataJSON:  null,
                                            lumber:    newLumberId
                                        },
                                        withCredentials: true
                                    });
                                }
                            });

                            this.dataUpdated = true;
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveData"));
                        }
                    });

                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}lumber/`,
                        data: {
                            speciesId:   this.species.id,
                            Tn:          this.Tn,
                            Wn:          this.Wn,
                            Ts:          this.Ts,
                            Ws:          this.Ws,
                            BoardType:   1,
                            LengthsJSON: JSON.stringify(this.selectedLengths),
                            Price:       this.price,
                            Expenses:    this.expenses
                        },
                        withCredentials: true
                    }).then( response => {
                        if (response.data.status == "success") {
                            newLumberId = response.data.lumber.id;

                            this.filteredlumberGroups.forEach(group => {
                                if (this.selectedLumberGroupId.includes(group.id)) {
                                    this.axios({
                                        method: "patch",
                                        url: `${this.$config.apiURL}lumber_groups/${group.id}/`,
                                        data: {
                                            name: group.name,
                                            speciesId: group.speciesId,
                                            dataJSON:  null,
                                            lumber:    newLumberId
                                        },
                                        withCredentials: true
                                    });
                                }
                            });

                            this.dataUpdated = true;
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveData"));
                        }
                    });
                } else {
                    this.axios({
                        method: "post",
                        url: `${this.$config.apiURL}lumber/`,
                        data: {
                            speciesId:   this.species.id,
                            Tn:          this.Tn,
                            Wn:          this.Wn,
                            Ts:          this.Ts,
                            Ws:          this.Ws,
                            BoardType:   this.boardType,
                            LengthsJSON: JSON.stringify(this.selectedLengths),
                            Price:       this.price,
                            Expenses:    this.expenses
                        },
                        withCredentials: true
                    }).then( response => {
                        if (response.data.status == "success") {
                            newLumberId = response.data.lumber.id;

                            this.filteredlumberGroups.forEach(group => {
                                if (this.selectedLumberGroupId.includes(group.id)) {
                                    this.axios({
                                        method: "patch",
                                        url: `${this.$config.apiURL}lumber_groups/${group.id}/`,
                                        data: {
                                            name: group.name,
                                            speciesId: group.speciesId,
                                            dataJSON:  null,
                                            lumber:    newLumberId
                                        },
                                        withCredentials: true
                                    });
                                }
                            });

                            this.dataUpdated = true;
                        }
                    }).catch(error => {
                        if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveData") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveData"));
                        }
                    });

                }

                this.dialog = false;
            },

            /**
             * Обработчик нажатия кнопки сохранения
             */
            saveDataClick () {
                if (this.dimensionId == 0) {
                    this.saveData();
                } else {
                    this.updateData();
                }
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            },

            /**
             * Выбор всех длин
             */
            selectAll () {
                this.$nextTick(() => {
                    if (this.checkAllLen) {
                        this.selectedLengths = []
                    } else {
                        this.selectedLengths = this.lengths.slice()
                    }
                })
            },

            /**
             * Обновление данных
             */
            updateData () {
                this.axios({
                    method: "patch",
                    url: `${this.$config.apiURL}lumber/${this.dimensionId}/`,
                    data: {
                        speciesId:   this.species.id,
                        Tn:          this.Tn,
                        Wn:          this.Wn,
                        Ts:          this.Ts,
                        Ws:          this.Ws,
                        BoardType:   this.boardType,
                        LengthsJSON: JSON.stringify(this.selectedLengths),
                        Price:       this.price,
                        Expenses:    this.expenses
                    },
                    withCredentials: true
                }).then(() => {
                    this.dataUpdated = true;
                }).catch(error => {
                    if (error.response && error.response.status == 403 && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateData") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantUpdateData"));
                    }
                });

                this.filteredlumberGroups.forEach(group => {
                    let items;

                    if (this.selectedLumberGroupId.includes(group.id)) {
                        if (group.lumberIds.includes(this.dimensionId)) {
                            return;
                        } else {
                            items = group.lumberIds;
                            items.push(this.dimensionId);
                        }
                    } else {
                        if (group.lumberIds.includes(this.dimensionId)) {
                            items = [];
                            group.lumberIds.forEach(item => {
                                if (item != this.dimensionId) {
                                    items.push(item);
                                }
                            });
                        } else {
                            return;
                        }
                    }

                    this.axios({
                        method: "patch",
                        url: `${this.$config.apiURL}lumber_groups/${group.id}/`,
                        data: {
                            name: group.name,
                            speciesId: group.speciesId,
                            dataJSON:  JSON.stringify(items)
                        },
                        withCredentials: true
                    }).catch(error => {
                        if (error.response && error.response.status == 401) {
                            this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { window.location.reload(); }
                            );
                        } else if (error.response && error.response.status == 402) {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup") + ". " + this.$t("subscriptionExpired"));

                            // Удаление наблюдателя если установлен
                            if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                            // Отслеживание нажатия кнопки ok в диалоге
                            this.dialogWatcher = this.$watch(
                                "$refs.MessageBox.dialog",
                                () => { this.$emit("doLogout", true); }
                            );
                        } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                            this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                        } else if (error.response && error.response.status == 403) {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup") + ". " + this.$t("accessDenied"));
                        } else {
                            this.showMessageBox(this.$t("error"), this.$t("cantSaveLumberGroup"));
                        }
                    });

                });
                this.dialog = false;
            }
        }
    }
</script>
